import merge from 'lodash/merge.js';

import Group from '@/store/modules/groups/Group.js';
import Collection from '@/store/quill/Collection.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('group');

export default merge(Collection('Groups', Group), {
    state: {
        sort: {
            name: 'asc',
            category_name: null,
            users_count: null,
            created_at: null,
            updated_at: null,
        },
    },

    getters: {
        ...collectionHelpers.getters,
    },

    actions: {
        fetch: collectionHelpers.actions.fetch(({ context, queryBuilder }) => {
            const { getters, rootGetters } = context;

            queryBuilder.include(['category']).sort(getters.queryBuilderSorting).setPagination(getters.paginate);

            if (rootGetters['GroupsView/hasQuery']) {
                queryBuilder.raw({
                    search: rootGetters['GroupsView/searchQuery'],
                });
            }

            if (rootGetters['GroupsView/hasCategorySearch']) {
                queryBuilder.filter('category_id', rootGetters['GroupsView/searchCategory']);
            }
        }),

        fetchOne: collectionHelpers.actions.fetchOne(({ queryBuilder }) => {
            queryBuilder.include(['category', 'users', 'users.role']);
        }),

        addGroup: collectionHelpers.actions.addModel(({ queryBuilder }) => {
            queryBuilder.include(['category']);
        }),

        updateGroup: collectionHelpers.actions.updateModel(),

        removeChecked: collectionHelpers.actions.removeChecked(),

        clearSort: collectionHelpers.actions.clearSort,

        paginateAndFetch: collectionHelpers.actions.paginateAndFetch,
    },

    mutations: {
        UPDATE_MODEL: collectionHelpers.mutations.UPDATE_MODEL,

        CLEAR_SORTING: collectionHelpers.mutations.CLEAR_SORTING,
    },
});
